import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueKonva from 'vue-konva'
import Router from 'vue-router'
import Toasted from 'vue-toasted'


import { AuthService } from '@skinsoft/auth'
import { Firewall } from '@skinsoft/auth-ui'
import { Field, Form, LocalizedDate, LocalizedString } from '@skinsoft/ui'

import { 
    EntityFieldDataStore,
    AliasDataStore,
    AliasDataStore as CollaboratorDataStore,
    ConditionReportDataStore,
    ExpressionDataStore,
    InstitutionDataStore,
    ItemDataStore,
    ManifestationDataStore,
    ThesaurusDataStore,
    ThesaurusTermDataStore,
    TranslationDataStore,
    WorkDataStore,
    WorkspaceDataStore,
    MediaDataStore
} from '@skinsoft/entity'

import { ConditionReportPDFGenerator } from '@skinsoft/pdf-generator'

import {
    ConditionReportPDFTransferHelper,
    ImageTransferHelper,
    MediaTransferHelper,
} from '@skinsoft/media-transfer-helper'
import { SignerInputCard } from './app/component/signature-module/signer-input-card'
import { PDF_STEP_COMPLETE_TOPIC } from './busTopics'
import { messages, dateTimeFormats } from './locales'
import { MaskField } from '@skinsoft/record-mask/src/components/mask-field'

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.component('s-form', Form)
Vue.component('s-field', Field)
Vue.component('s-firewall', Firewall)
Vue.component('s-localized-date', LocalizedDate)
Vue.component('s-localized-string', LocalizedString)
Vue.component('s-mask-field', MaskField)

Vue.use(BootstrapVue)
Vue.use(Router)
Vue.use(Toasted)
Vue.use(VueKonva)
Vue.use(AuthService)
Vue.use(VueI18n)

Vue.use(TranslationDataStore)
Vue.use(EntityFieldDataStore)

Vue.use(AliasDataStore)
Vue.use(CollaboratorDataStore)
Vue.use(ThesaurusTermDataStore)
Vue.use(ThesaurusDataStore)
Vue.use(InstitutionDataStore)
Vue.use(WorkspaceDataStore)

Vue.use(ItemDataStore)
Vue.use(ManifestationDataStore)
Vue.use(ExpressionDataStore)
Vue.use(WorkDataStore)
Vue.use(ConditionReportDataStore)
Vue.use(MediaDataStore)

Vue.use(MediaTransferHelper)
Vue.use(ConditionReportPDFTransferHelper)
Vue.use(ImageTransferHelper)

Vue.use(ConditionReportPDFGenerator, {
    i18nMessages: messages,
    i18nDatesTimeFormat: dateTimeFormats,
    defaultSignatrueCanvasWidth: SignerInputCard.DEFAULT_SIGNATURE_CANVAS_WIDTH,
    defaultSignatrueCanvasHeight: SignerInputCard.DEFAULT_SIGNATURE_CANVAS_HEIGHT,
    topicToEmitProgress: PDF_STEP_COMPLETE_TOPIC,
})

if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev') {
    Vue.config.devtools = true;
    Vue.config.productionTip = false;
} else {
    Vue.config.devtools = false;
    Vue.config.productionTip = true;
}
